export default __webpack_public_path__ + "static/media/terms-of-use.818a5442.pdf";